import React from "react";

export default ({ setLoginInfo, setSpinner }) => {
    const logout = async () => {
        setSpinner(true);
        try {
            await fetch("/api/logout", {
                method: "POST"
            });
        } catch {
            alert('Signing out failed.');
        } finally {
            setLoginInfo({});
        }

        setSpinner(false);
    }
    return (<button onClick={logout}>Sign out</button>);
};